export * from './formatters'
export * from './validators'
export * from './useCountdown'

export const getExpirationTimeInSeconds = (duration = 60 * 60): bigint => {
  const secondsFromNow =
    BigInt(Math.round(new Date().getTime() / 1000)) + BigInt(duration)

  return secondsFromNow
}
